/*
@function calculateBathroomsScore
@param {Object} listing
@param {String} filterValue
*/
function calculateBathroomsScore(listing, filterValue) {
    var weight = 1;
    var value = 0;
    var threshold = 0;

    if(filterValue === '1-2') {
        if(listing.baths <= 2) {
            value = 10;
        } else if(listing.baths <= 4) {
            value = 0;
        } else {
            value = -10;
        }
    } else if(filterValue === '3-4') {
        if(~[3,4].indexOf(listing.baths)) {
            value = 10;
        } else {
            value = 0;
        }
    } else if(filterValue === '5+') {
        if(listing.beds >= 5) {
            value = 10;
        } else if(listing.beds >= 3) {
            value = 0;
        } else {
            value = -10;
        }
    }

    return {
        weight: weight,
        value: value,
        score: value * weight,
        metThreshold: (value * weight) >= threshold,
        metWhyWhyNotThreshold: (value * weight) >= 10
    };
}

module.exports = calculateBathroomsScore;
